import moment from 'moment-timezone';
import { store } from "../../../index";

const DateTimeUtils = {

    _convertUnixToDateTime(
        unixTimestamp,
        userTimeZone = 'UTC',
        displayAsString = false,
        hasDate = true,
        hasTime = true,
        hasSeconds = true
    ) {
        const convertedMoment = moment(unixTimestamp).tz(userTimeZone);

        return displayAsString ?
                hasDate && hasTime ?
                    convertedMoment.format('DD/MM/YYYY HH:mm:ss') :
                    hasDate ?
                        convertedMoment.format('DD/MM/YYYY') :
                        hasTime && hasSeconds ?
                            convertedMoment.format('HH:mm:ss') :
                            convertedMoment.format('HH:mm') :
            convertedMoment ;
    },

    _convertUnixToDateTimeWithUserTimezone(
        unixTimestamp,
        displayAsString = false,
        hasDate = true,
        hasTime = true,
        hasSeconds = true
    ) {
        return this._convertUnixToDateTime(
            unixTimestamp,
            this.getUserTimeZone(),
            displayAsString,
            hasDate,
            hasTime,
            hasSeconds
        );
    },

    getDateTimeFromUnix(unixTimestamp, displayAsString = true) {
        return this._convertUnixToDateTimeWithUserTimezone(
            unixTimestamp,
            displayAsString,
            true,
            true,
            true
        )
    },

    getDateFromUnix(unixTimestamp) {
        return this._convertUnixToDateTimeWithUserTimezone(
            unixTimestamp,
            true,
            true,
            false,
            false
        )
    },

    getTimeFromUnix(unixTimestamp) {
        return this._convertUnixToDateTimeWithUserTimezone(
            unixTimestamp,
            true,
            false,
            true,
            true
        )
    },

    getTimeWithoutSecondsFromUnix(unixTimestamp) {
        return this._convertUnixToDateTimeWithUserTimezone(
            unixTimestamp,
            true,
            false,
            true,
            false
        )
    },

    getTimezoneDataForDropdown() {
        return moment.tz.names().map(op => ({
            'value': op,
            'offset': moment.tz(op).format('Z'),
            'label': '(GMT' + moment.tz(op).format('Z') + ') ' + op
        }));
    },

    getMomentForTodayWithTime(hours, minutes, seconds, millis) {
        return this.getDateTimeFromUnix(undefined, false).hours(hours).minutes(minutes).seconds(seconds).milliseconds(millis);
    },

    getMomentForBeginningOfWeek() {
        return new Date(moment().startOf('week').format());
    },

    getMomentForEndOfWeek() {
        return new Date(moment().endOf('week').format());
    },

    getUserTimeZone() {
        return store.getState().authReducer.user.timeZone;
    }
};

const CompareDatesUtils = {
    dateIsOnTheSameDayAsDate(unixTimestamp1, unixTimestamp2) {
        const moment1 = moment(unixTimestamp1);
        const moment2 = moment(unixTimestamp2);

        return moment1.year() === moment2.year() &&
            moment1.month() === moment2.month() &&
            moment1.date() === moment2.date();
    }
};

const TimeZoneUtils = {
    getUserTimezoneOffsetInSeconds() {
        return moment.tz(moment(), DateTimeUtils.getUserTimeZone()).utcOffset();
    }
}

export default DateTimeUtils;
export {
    CompareDatesUtils,
    TimeZoneUtils
};